<template>
  <div>
    <div class="grid cross-center ver-padding-40">
      <h1 class="r-margin-30">Пользователи ({{ totalUsers }})</h1>
      <div class="u-16 u-ls grid cross-center between">
        <div class="u-16 u-5-ss u-6-ms ver-padding-10 ver-padding-0-ls">
          <AppInput
            v-model="search"
            size="small"
            placeholder="Найти по email или имени"
          ></AppInput>
        </div>
        <div>
          <AppButton type="white" size="mini" @click="loadUsers"
            >Обновить</AppButton
          >
          <AppButton size="mini" @click="addUser"
            >Добавить пользователя</AppButton
          >
        </div>
      </div>
    </div>

    <div class="page-block ver-margin-15 grid table-settings">
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.is_active"
        id="option-active"
        >Включен</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.is_confirm"
        id="option-confirm"
        >Подтвержден</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.is_admin"
        id="option-admin"
        >Админ</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.merchants"
        id="option-merchants"
        >Предприятия</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.terminals"
        id="option-terminals"
        >Терминалы</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.processings"
        id="option-processings"
        >Процессинг</AppCheckbox
      >
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.rules"
        id="option-rules"
        >Права</AppCheckbox
      >
    </div>

    <div v-loading="loading">
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <el-table
          :data="
            users.filter(
              data =>
                !search ||
                data.email.toLowerCase().includes(search.toLowerCase()) ||
                data.full_name.toLowerCase().includes(search.toLowerCase())
            )
          "
          :default-sort="{ prop: 'date_created', order: 'descending' }"
          style="width: 100%"
          class="user-table"
          size="medium"
          @row-click="rowClick"
          ref="userstable"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="grid">
                <div class="togglerow" @click="rowClick(props.row)"></div>
                <div class="u grid padding-30">
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Создан:</div>
                    <div class="u hor-padding-10">
                      {{ props.row.date_created | momentFormat() }}
                    </div>
                  </div>
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Email:</div>
                    <div class="u hor-padding-10">
                      <a
                        v-if="props.row.email"
                        :href="'mailto:' + props.row.email"
                        target="blank"
                        >{{ props.row.email }}</a
                      >
                      <span v-else>—</span>
                    </div>
                  </div>
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Предприятия:</div>
                    <div class="u hor-padding-10">
                      <div v-if="props.row.access_list.Merchants">
                        <el-tag
                          :key="index"
                          v-for="(merch, index) in props.row.access_list
                            .Merchants"
                          type="info"
                          effect="light"
                          >{{ merchantName(merch) }}</el-tag
                        >
                      </div>
                      <span v-else>—</span>
                    </div>
                  </div>
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Терминалы:</div>
                    <div class="u hor-padding-10">
                      <div v-if="props.row.access_list.Terminals">
                        <el-tag
                          :key="index"
                          v-for="(terminal, index) in props.row.access_list
                            .Terminals"
                          type="info"
                          effect="light"
                          >{{ terminalName(terminal) }}</el-tag
                        >
                      </div>
                      <span v-else>—</span>
                    </div>
                  </div>
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Процессинги:</div>
                    <div class="u hor-padding-10">
                      <div v-if="props.row.access_list.Processings">
                        <el-tag
                          :key="index"
                          v-for="(proc, index) in props.row.access_list
                            .Processings"
                          type="info"
                          effect="light"
                          >{{ processingName(proc) }}</el-tag
                        >
                      </div>
                      <span v-else>—</span>
                    </div>
                  </div>
                  <div class="u-16 grid ver-margin-5 cross-center">
                    <div class="access-name">Права:</div>
                    <div class="u hor-padding-10">
                      <div v-if="props.row.rights">
                        <el-tag
                          :key="index"
                          v-for="(right, index) in props.row.rights"
                          type="success"
                          effect="light"
                          >{{ right | showRightsName }}</el-tag
                        >
                      </div>
                      <span v-else>—</span>
                    </div>
                  </div>
                  <hr class="u-16 ver-margin-10" />
                  <div class="u-16 ver-margin-5 grid">
                    <div>
                      <AppButton
                        class="r-margin-20"
                        size="small"
                        @click="handleEdit(props.$index, props.row)"
                        >Изменить</AppButton
                      >
                      <AppButton
                        v-if="props.row.email"
                        class="r-margin-20"
                        size="small"
                        @click="handleResetPassword(props.$index, props.row)"
                        >Сбросить пароль</AppButton
                      >
                    </div>
                    <AppButton
                      size="small"
                      :type="props.row.active ? 'red' : 'green'"
                      @click="
                        handleSwitch(props.$index, props.row, !props.row.active)
                      "
                      >{{ textActivateButton(props.row.active) }}</AppButton
                    >
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="id" sortable label="#" width="70"></el-table-column> -->
          <el-table-column
            prop="date_created"
            sortable
            label="Создан"
            width="150"
          >
            <template slot-scope="scope">{{
              scope.row.date_created | momentFormat()
            }}</template>
          </el-table-column>
          <el-table-column
            prop="email"
            sortable
            label="Email"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="full_name"
            sortable
            label="Имя"
            min-width="150"
          ></el-table-column>
          <el-table-column
            min-width="100"
            label="Включен"
            prop="active"
            align="center"
            v-if="columns.is_active"
            :filters="[
              { text: 'Да', value: true },
              { text: 'Нет', value: false }
            ]"
            :filter-method="filterHandler"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.active"><i class="el-icon-check"></i></div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="130"
            label="Подтвержден"
            prop="is_confirm_email"
            align="center"
            v-if="columns.is_confirm"
            :filters="[
              { text: 'Да', value: true },
              { text: 'Нет', value: false }
            ]"
            :filter-method="filterHandler"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.is_confirm_email">
                <i class="el-icon-check"></i>
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100"
            label="Админ"
            align="center"
            prop="is_admin"
            v-if="columns.is_admin"
            :filters="[
              { text: 'Да', value: true },
              { text: 'Нет', value: false }
            ]"
            :filter-method="filterHandler"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.is_admin">
                <i class="el-icon-star-on"></i>
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="access_list.Merchants"
            min-width="150"
            label="Предприятия"
            v-if="columns.merchants"
            :filters="constructorFilter('Merchants')"
            :filter-method="filterMerchant"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.access_list.Merchants">
                <el-tag
                  :key="index"
                  v-for="(item, index) in listOfTags(
                    scope.row.access_list.Merchants,
                    1
                  )"
                  type="info"
                  effect="light"
                  >{{ merchantName(item) }}</el-tag
                >
                <el-tag
                  v-if="
                    scope.row.access_list.Merchants &&
                      scope.row.access_list.Merchants.length > 1
                  "
                  type="info"
                  effect="light"
                  >+
                  {{ countResidue(scope.row.access_list.Merchants, 1) }}</el-tag
                >
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="access_list.Terminals"
            min-width="150"
            label="Терминалы"
            v-if="columns.terminals"
            :filters="constructorFilter('Terminals')"
            :filter-method="filterTerminal"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.access_list.Terminals">
                <el-tag
                  :key="index"
                  v-for="(item, index) in listOfTags(
                    scope.row.access_list.Terminals,
                    1
                  )"
                  type="info"
                  effect="light"
                  >{{ terminalName(item) }}</el-tag
                >
                <el-tag
                  v-if="
                    scope.row.access_list.Terminals &&
                      scope.row.access_list.Terminals.length > 1
                  "
                  type="info"
                  effect="light"
                  >+
                  {{ countResidue(scope.row.access_list.Terminals, 1) }}</el-tag
                >
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="access_list.Processings"
            min-width="190"
            label="Процессинги"
            v-if="columns.processings"
            :filters="constructorFilter('Processings')"
            :filter-method="filterProcessing"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.access_list.Processings">
                <el-tag
                  :key="index"
                  v-for="(item, index) in listOfTags(
                    scope.row.access_list.Processings,
                    1
                  )"
                  type="info"
                  effect="light"
                  >{{ processingName(item) }}</el-tag
                >
                <el-tag
                  v-if="
                    scope.row.access_list.Processings &&
                      scope.row.access_list.Processings.length > 1
                  "
                  type="info"
                  effect="light"
                  >+
                  {{
                    countResidue(scope.row.access_list.Processings, 1)
                  }}</el-tag
                >
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="rights"
            min-width="170"
            label="Права"
            v-if="columns.rules"
            :filters="constructorFilterRights"
            :filter-method="filterRights"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.rights">
                <el-tag
                  :key="index"
                  v-for="(item, index) in listOfTags(scope.row.rights, 1)"
                  type="success"
                  effect="light"
                  >{{ item | showRightsName }}</el-tag
                >
                <el-tag
                  v-if="scope.row.rights.length > 1"
                  type="success"
                  effect="light"
                  >+ {{ countResidue(scope.row.rights, 1) }}</el-tag
                >
              </div>
              <div v-else><i class="el-icon-minus"></i></div>
            </template>
          </el-table-column>
          <div slot="empty">
            <div>{{ errorMessage }}</div>
          </div>
        </el-table>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import rightsList from "@/localize/rightsList.js";
Vue.use(VueAxios, axios);

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "Users",
  data() {
    return {
      loading: false,
      search: "",
      totalUsers: 0,
      users: [],
      userUpdate: [],
      errorMessage: "Нет данных",
      columns: {
        is_active: true,
        is_confirm: true,
        is_admin: true,
        merchants: true,
        terminals: true,
        processings: true,
        rules: true
      },
      scrollsettings: {
        suppressScrollY: true,
        swipeEasing: true
      }
    };
  },
  methods: {
    loadUsers() {
      this.errorMessage = "Загрузка...";
      this.loading = true;
      this.users = [];
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "user/list", config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.users = data.list;
            this.totalUsers = data.total || this.users.length;
            this.errorMessage = this.users.length == 0 ? "Нет данных" : "";
            this.loading = false;
          }
        })
        .then(() => {
          this.search = this.$route.params.filter || "";
          if (this.users.length > 0) {
            this.$refs.userstable.toggleRowExpansion(
              this.users.find(el => el.id == this.$route.params.id),
              true
            );
          }
        })
        .catch(({ response }) => {
          if (response.status != 200) this.loading = false;
          this.errorMessage =
            "(" +
            response.status +
            ") Невозможно загрузить список пользователей";
        });
    },
    loadUser(id) {
      let user = [];
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "user/list/" + id, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            user = data.list[0];
            this.updateUser(id, user);
          }
        })
        .catch(err => {
          console.log(err);
          false;
        });
    },
    updateUser(id, user) {
      let foundIndex = this.users.findIndex(el => el.id === id);
      let oldUser = this.users.find(el => el.id === id);
      this.$set(oldUser, "active", user.active);
    },
    addUser() {
      this.$router.push("create_user");
    },
    rowClick(row) {
      this.$refs.userstable.toggleRowExpansion(row);
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "s_EditUser",
        params: { id: row.id, user: row, filter: this.search }
      });
    },
    handleResetPassword(index, row) {
      this.hideScroll();
      const text = "Сбросить пароль у пользователя <b>";
      this.$confirm(text + row.email + "</b>?", "", {
        confirmButtonText: "OK",
        cancelButtonText: "Отмена",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.showScroll();
          this.sendEmail(row.id);
        })
        .catch(() => {
          this.showScroll();
        });
    },
    handleSwitch(index, row, action) {
      this.hideScroll();
      const text = action ? "Включить" : "Отключить";
      this.$confirm(text + " пользователя <b>" + row.email + "</b>?", "", {
        confirmButtonText: "OK",
        cancelButtonText: "Отмена",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.showScroll();
          this.switchUser(row.id, action, row.email);
        })
        .catch(() => {
          this.showScroll();
        });
    },
    switchUser(id, active, email) {
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      const text = active ? "подключен" : "отключен";
      axios
        .post(apiUrl + "user/switch/" + id, { active }, config)
        .then(response => {
          this.$message({
            type: "success",
            message: "Пользователь " + email + " успешно " + text
          });
        })
        .then(response => {
          this.loadUser(id);
        })
        .catch(err => {
          console.log(err);
        });
    },
    sendEmail(userId) {
      let host = "";
      let path = "/";
      let origin = window.location.origin;
      if (/bo-dev|localhost/.test(origin)) {
        host = "https://auth-dev.mapcard.pro";
        path = apiUrl.match(/\/(feature-.*|develop)\//)[0];
      }
      if (/bo-stage/.test(origin)) host = "https://auth-stage.mapcard.pro";
      if (/bo-evo/.test(origin)) host = "https://auth-evo.mapcard.pro";
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(
          host + path + "change-password",
          { id: userId, reset_password: true },
          config
        )
        .then(({ data }) => {
          if (data.state_id == 0)
            this.$message({
              message: "Письмо на сброс пароля отправлено",
              type: "success",
              duration: 2000
            });
        })
        .catch(err => {
          if (err.response)
            this.$message({
              message: err.response.data.message,
              type: "error",
              duration: 2000
            });
        });
    },
    listOfTags(items, count) {
      if (items) {
        if (items.length <= count) return items;
        else return items.filter((el, index) => index < count);
      }
    },
    countResidue(items, count) {
      if (items) {
        if (items.length > count) return items.length - count;
        else return items.length;
      }
    },
    textActivateButton(prop) {
      return prop ? "Отключить" : "Включить";
    },
    constructorFilter(prop) {
      if (this.users) {
        const arr = _.uniq(
          // remove duplicates
          this.users
            .map(el => el.access_list[prop]) // get list of merchants
            .filter(el => el) // remove null elements
            .reduce((p, n) => p.concat(n), []) // merge to array
        )
          .sort((a, b) => a - b)
          .map(el => {
            if (prop == "Merchants")
              return { text: this.merchantName(el), value: el };
            if (prop == "Terminals")
              return { text: this.terminalName(el), value: el };
            if (prop == "Processings")
              return { text: this.processingName(el), value: el };
          }); // sort array
        return arr;
      }
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterMerchant(value, row, column) {
      if (row.access_list.Merchants)
        return row.access_list.Merchants.indexOf(value) != -1;
    },
    filterTerminal(value, row, column) {
      if (row.access_list.Terminals)
        return row.access_list.Terminals.indexOf(value) != -1;
    },
    filterProcessing(value, row, column) {
      if (row.access_list.Processings)
        return row.access_list.Processings.indexOf(value) != -1;
    },
    filterRights(value, row, column) {
      if (row.rights) return row.rights.indexOf(value) != -1;
    },
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    }
  },
  computed: {
    ...mapGetters(["merchantName", "terminalName", "processingName"]),
    constructorFilterRights() {
      if (this.users) {
        const arr = _.uniq(
          this.users
            .map(el => el.rights)
            .filter(el => el)
            .reduce((p, n) => p.concat(n), [])
        ).map(el => {
          let item = rightsList.find(q => q.value == el);
          return { text: item ? item.label : el, value: el };
        });
        return arr;
      }
    }
  },
  filters: {
    showRightsName(value) {
      if (!value) return "";
      let item = rightsList.find(el => el.value == value);
      return item ? item.label : "";
    }
  },
  created() {
    this.loadUsers();
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>
